import { Icon } from '@/components';

export function ItemIcon({ color }: { color?: string; title?: string }) {
  return <Icon style={{ fontSize: '0.6rem', color }} type="rectangle" />;
}
